import { type DocumentNode, gql } from '@apollo/client';
import {
  ALLOW_SELF_REGISTRATION,
  CUSTOM_LOGIN_MESSAGE,
  DEFAULT_PERMISSIONS_GROUP,
  DEFAULT_SSO_PERMISSIONS_DELETE,
  DEFAULT_SSO_PERMISSIONS_DOWNLOAD,
  DEFAULT_SSO_PERMISSIONS_EDIT,
  DEFAULT_SSO_PERMISSIONS_GROUP,
  DEFAULT_SSO_PERMISSIONS_SHARE,
  DOWNLOAD_HIRES,
  DOWNLOAD_MARKERS,
  EMAIL_FROM_ADDRESS,
  ENABLE_OAUTH,
  LICENSE,
  //OKTA_AUDIENCE,
  OAUTH_CLIENT_ID,
  OAUTH_CLIENT_SECRET,
  OAUTH_PROVIDER_NAME,
  OIDC_DISCOVERY_URL,
  SITE_TITLE,
  SMTP_HOST,
  SMTP_PASSWORD,
  SMTP_PORT,
  SMTP_USER,
} from 'src/constants';

const systemSettingConfig: DocumentNode = gql`
  query systemSettingConfigs{
      ${CUSTOM_LOGIN_MESSAGE}: allConfigurations(optionKey:"${CUSTOM_LOGIN_MESSAGE}") {
        edges {
            node {
             id
             optionKey
             optionValue
             optionScope
            }
        }
      }
      ${DOWNLOAD_MARKERS}: allConfigurations(optionKey:"${DOWNLOAD_MARKERS}") {
        edges {
            node {
             id
             optionKey
             optionValue
             optionScope
            }
        }
      }
      ${DOWNLOAD_HIRES}: allConfigurations(optionKey:"${DOWNLOAD_HIRES}") {
        edges {
            node {
             id
             optionKey
             optionValue
             optionScope
            }
        }
      }
      ${ENABLE_OAUTH}: allConfigurations(optionKey:"${ENABLE_OAUTH}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${OAUTH_CLIENT_ID}: allConfigurations(optionKey:"${OAUTH_CLIENT_ID}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${OAUTH_CLIENT_SECRET}: allConfigurations(optionKey:"${OAUTH_CLIENT_SECRET}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${OAUTH_PROVIDER_NAME}: allConfigurations(optionKey:"${OAUTH_PROVIDER_NAME}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${OIDC_DISCOVERY_URL}: allConfigurations(optionKey:"${OIDC_DISCOVERY_URL}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${SITE_TITLE}: allConfigurations(optionKey:"${SITE_TITLE}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${SMTP_HOST}: allConfigurations(optionKey:"${SMTP_HOST}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${SMTP_PASSWORD}: allConfigurations(optionKey:"${SMTP_PASSWORD}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${SMTP_PORT}: allConfigurations(optionKey:"${SMTP_PORT}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${SMTP_USER}: allConfigurations(optionKey:"${SMTP_USER}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${EMAIL_FROM_ADDRESS}: allConfigurations(optionKey:"${EMAIL_FROM_ADDRESS}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${ALLOW_SELF_REGISTRATION}: allConfigurations(optionKey:"${ALLOW_SELF_REGISTRATION}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${DEFAULT_PERMISSIONS_GROUP}: allConfigurations(optionKey:"${DEFAULT_PERMISSIONS_GROUP}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${DEFAULT_SSO_PERMISSIONS_GROUP}: allConfigurations(optionKey:"${DEFAULT_SSO_PERMISSIONS_GROUP}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${DEFAULT_SSO_PERMISSIONS_EDIT}: allConfigurations(optionKey:"${DEFAULT_SSO_PERMISSIONS_EDIT}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${DEFAULT_SSO_PERMISSIONS_SHARE}: allConfigurations(optionKey:"${DEFAULT_SSO_PERMISSIONS_SHARE}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${DEFAULT_SSO_PERMISSIONS_DOWNLOAD}: allConfigurations(optionKey:"${DEFAULT_SSO_PERMISSIONS_DOWNLOAD}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${DEFAULT_SSO_PERMISSIONS_DELETE}: allConfigurations(optionKey:"${DEFAULT_SSO_PERMISSIONS_DELETE}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }
      ${LICENSE}: allConfigurations(optionKey:"${LICENSE}") {
        edges {
            node {
              id
              optionKey
              optionValue
              optionScope
            }
        }
      }

    }
`;

export default systemSettingConfig;
